var swiper = new Swiper(".theProducts", {
  slidesPerView: 1,
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 50,
    },
  },
});

// Get the popup
var popup = document.getElementsByClassName("popup")[0];
// Get the video
var video = document.getElementById("popupVideo");
// Get the buttons that open the popup
var openBtns = document.getElementsByClassName("openPopupBtn");
// Get the <span> element that closes the popup
var closeBtn = document.getElementsByClassName("close-btn")[0];
// Add click event to all buttons
for (var i = 0; i < openBtns.length; i++) {
  openBtns[i].onclick = function () {
    popup.style.display = "inline-flex";
    video.play(); // Autoplay video when popup opens
  };
}
// When the user clicks on <span> (x), close the popup and pause the video
closeBtn.onclick = function () {
  popup.style.display = "none";
  video.pause(); // Pause video when popup closes
  video.currentTime = 0; // Reset video to the start
};
// When the user clicks anywhere outside of the popup, close it and pause the video
window.onclick = function (event) {
  if (event.target == popup) {
    popup.style.display = "none";
    video.pause(); // Pause video when popup closes
    video.currentTime = 0; // Reset video to the start
  }
};
